<!-- ContactCard.vue -->
<template>
  <div
    role="button"
    :aria-pressed="active"
    :aria-live="statusLive ? 'polite' : 'off'"
    tabindex="0"
    @keydown.enter.prevent="onSelect"
    @click="onSelect"
    class="relative bg-white rounded-2xl p-6 shadow-lg transform transition hover:-translate-y-1 hover:shadow-2xl focus:outline-none focus:ring-4 focus:ring-primary/50 cursor-pointer">
    <div class="text-4xl mb-4 inline-block" :class="{ 'animate-pulse': statusLive }" aria-hidden="true">{{ icon }}</div>
    <h3 class="text-lg font-medium mb-1">{{ title }}</h3>
    <p class="text-sm text-gray-600" v-html="description"></p>
    <div v-if="active" class="absolute inset-0 border-4 border-primary/60 rounded-2xl pointer-events-none" />
  </div>
</template>

<script setup lang="ts">
import { defineProps, defineEmits } from "vue";

const props = defineProps<{
  icon: string;
  title: string;
  description: string;
  active: boolean;
  statusLive?: boolean;
}>();

const emit = defineEmits<{
  (e: "select"): void;
}>();

function onSelect() {
  emit("select");
}
</script>
